import './App.css';
import hero from './img/hero01.png';
import hero2 from './img/hero02.jpg';
import hero3 from './img/hero03.png';
import Grid from '@mui/material/Grid';
import LockIcon from '@mui/icons-material/Lock';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

function createData(
  rank,
  reward,
  condition,
) {
  return { rank, reward, condition };
}

const rows = [
  createData('1', "3,000 USDT", "Trading Volume 200,000 USDT"),
  createData('2', "1,500 USDT", "Trading Volume 200,000 USDT"),
  createData('3', "700 USDT", "Trading Volume 200,000 USDT"),
  createData('4', "200 USDT", "Trading Volume 100,000 USDT"),
  createData('5', "200 USDT", "Trading Volume 100,000 USDT"),
];

const MyButton = styled(Button)({
  backgroundColor: '#9EE05A',
  color: "#fff",
  '&:hover': {
    backgroundColor: '#fff',
    color: "#9EE05A"
  },
  fontSize: "20px",
  fontWeight: 500,
})

function App() {
  return (
    <div className="app">
      <header>
        <style>
          @import url('https://fonts.googleapis.com/css2?family=Roboto+Flex:opsz,wght@8..144,400;8..144,500;8..144,700&display=swap');
        </style>
      </header>
      
        <Grid container className="content">
          <Grid item xs={12}><img className="hero" src={hero3}/></Grid>
          <Grid item xs={10} lg={8}>
            <h1>PlayV Run Season 2</h1> 
            <h2 style={{marginBottom:"0px"}}>The Final Match</h2>
            <h6 style={{color:"#fff", margin: "10px 0 50px 0", textAlign: "center"}}>PlayV, a cryptocurrency social trading platform, announces the opening of ‘PlayV Run Season 2: The Final Match’!
                <br/>
              Participate in THREE rounds of trading competitions called ‘PlayV Run Season 2’ with a total prize pool of 3 BTC!</h6>

            <h3>The schedule of the competition</h3>
            <h4>First Round [Finished!]</h4>
            <h6><s><em>Trader Application period(12D):</em> 8/18/2022 3pm - 8/29/2022 3pm (UTC +9)</s></h6>
            <h6><s><em>The Competition Duration(21D):</em> 8/29/2022 3pm - 9/19/2022 3pm (UTC +9)</s></h6>

            <h4>Second Round [Finished!]</h4>
            <h6><s><em>Trader Application period(14D):</em> 10/4/2022 3pm - 10/17/2022 3pm (UTC +9)</s></h6>
            <h6><s><em>The Competition Duration(29D):</em> 10/17/2022 3pm - 11/14/2022 3pm (UTC +9)</s></h6>

            <h4>Third Round</h4>
            <h6><em>Trader Application period(15D):</em> 12/5/2022 3pm - 12/19/2022 3pm (UTC +9)</h6>
            <h6><em>The Competition Duration(22D):</em> 12/19/2022 3pm - 1/9/2023 3pm (UTC +9)</h6>

            <h3>3nd Round: Prizes and Bonuses</h3>
            <h4>Traders: <span style={{color:"white"}}>Set up an investment strategy, demonstrate your skills through trading and win prize money.</span></h4>
            {/* <h5>- TOP 10 Strategies by ROI(8,500U):  <span style={{color:"white"}}>Traders who prove their trading skills with high cumulative ROI will share the Prize Pool.</span></h5> */}
            <h4>Investors: <span style={{color:"white"}}>Participate in the Trading Contest just by “PURCHASING” a strategy of the Trader you SUPPORT.</span></h4>

            <Grid xs={12} lg={8} style={{margin: "10px 0 15px 25px"}}>
              <TableContainer component={Paper} style={{background:"rgba(255,255,255, 0.9)"}}className="mytb">
                <Table style={{tableLayout:"fixed" }} >
                  <TableHead>
                    <TableRow>
                      <TableCell >Rank</TableCell>
                      <TableCell >Reward</TableCell>
                      <TableCell >Eligibility Requirements</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows.map((row) => (
                        <TableRow key={row.rank}>
                          <TableCell >{row.rank}</TableCell>
                          <TableCell >{row.reward}</TableCell>
                          <TableCell >{row.condition}</TableCell>
                        </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
            <p style={{marginLeft:25}}>* All prizes will be paid in USDT</p>
            {/* <h5>- [BONUS EVENT] Whale Catcher(1,000U): <span style={{color:"white"}}>A Trader with the highest Total Asset in one’s Strategy at the end of the competition TAKES ALL.</span></h5>
            <h5>- [BONUS EVENT] King of the Mountain(2,000U): <span style={{color:"white"}}>Traders who meet the Trading Volume of 700,000U automatically join the LUCKY DRAW.</span></h5>
            <h5 style={{color:"white"}}>- 200U Bonus for early-registered Traders</h5>
            <h5 style={{color:"white"}}>- Trading Fee 50% off</h5>
            <h5 style={{color:"white"}}>- SNS Promotion for TOP 3 Winners</h5> */}

            {/* <h5>- [BONUS EVENT] Find The Darkhorse(1,600U): <span style={{color:"white"}}>Investors of the TOP 3 and the BOTTOM ranked strategies will join the LUCKY DRAW. Strategy Purchases should be done one week before the end of competition.</span></h5>
            <h5>- [BONUS EVENT] King of the Investors(1,000U): <span style={{color:"white"}}>An investor with the highest PROFIT AMOUNT during the competition TAKES ALL.</span></h5> */}
            <h4>[General Benefits for Traders]</h4>
            <h6>- Trading Fee 50% off (Trading fee 50% off benefit is only for Contest Period)</h6>
            <h6>- SNS Promotion for TOP 3 Winners </h6>
    
            <h4>[Event for Traders only]</h4>
            <h5>[Double-up Event]</h5>
            <h6>- PlayV will purchase 2x of trader’s First Investment Amount(Seed) (Max. 500 USDT)</h6>
            <h6>- This event will be subject to the first 20 traders who complete creating and buying strategy.</h6>
            <h6>- Event participants should submit the survey to prove your purchase</h6>
            <h6>- PlayV’s seed support also will be considered as total asset. </h6>

            <h4>[Referral Events for Traders & Investors]</h4>
            
            <h5>[Join PlayV with invitation code]</h5>
            <h6>- Join PlayV with trader’s invitation code and earn ‘20 USDT’</h6>
            <h6>- Invitation code should be from traders who join 3rd trading contest</h6>
            <h6>- The prize will be given to the first 100 users</h6>
            
            <h5>[Invite your Friends]</h5>
            <h6>- Invite friends and earn ‘10 USDT / sign-up friend’</h6>
  
            <h5>[Lucky Draw]</h5>
            <h6>- Join PlayV with the invitation code and buy strategy to be the winner for 100 USDT</h6>
            <h6>- Awarded to 5 winners</h6>
            
                <br />
                <h4 style={{color:"#E671D3"}}>NOTE: Before joining the events , make sure to read Events Details.</h4>
                <br />
            <h4>For More Details, GO TO EVENT DETAILS</h4>
            <Grid item lg={12} xl={4} className="button" style={{marginBottom:30}}>
              <MyButton variant="contained" href="https://amazing-wash-26b.notion.site/PlayV-Run-Season-2-302ab9d29ca44e569e82cf79ee41db4e">Go To EVENT DETAILS</MyButton>
            </Grid>

            <h4>Final Ranking Board will be updated on 01/10/2023 at 17:00 (UTC+9).</h4>
            <Grid item lg={12} xl={4} className="button" style={{marginBottom:100}}>
              <MyButton variant="contained" href="https://amazing-wash-26b.notion.site/PlayV-Run-Season-2-Ranking-Board-9dc30de9150f4815bcb0d704ed04c6b3">Go To Ranking Board</MyButton>
            </Grid>
          </Grid>
        </Grid>
      
    </div>
  );
}

export default App;
